var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakaoChannelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2378_6142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 31.0994C40 36.0157 36.0147 40 31.1002 40H8.89975C3.98533 40 0 36.0157 0 31.0994V8.90059C0 3.98433 3.98533 0 8.89975 0H31.1002C36.0147 0 40 3.98433 40 8.90059V31.1021V31.0994Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4784 8.73291C13.4911 8.73291 7.8269 13.9409 7.8269 20.3672C7.8269 25.1132 9.82636 27.3796 12.5647 29.4433L12.5783 29.4487V35.0187C12.5783 35.2834 12.8799 35.432 13.0918 35.2753L17.8894 31.734L17.9926 31.7772C18.7967 31.9258 19.628 32.0014 20.4784 32.0014C27.4656 32.0014 33.1271 26.7934 33.1271 20.3672C33.1271 13.9409 27.4629 8.73291 20.4784 8.73291Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4784 7.02344C13.4911 7.02344 7.8269 12.2314 7.8269 18.6577C7.8269 23.4038 9.82636 25.6701 12.5647 27.7339L12.5783 27.7393V33.3092C12.5783 33.5739 12.8799 33.7225 13.0918 33.5658L17.8894 30.0245L17.9926 30.0677C18.7967 30.2163 19.628 30.2919 20.4784 30.2919C27.4656 30.2919 33.1271 25.0839 33.1271 18.6577C33.1271 12.2314 27.4629 7.02344 20.4784 7.02344ZM16.2377 21.6074C17.4792 21.6074 18.5387 20.87 18.8592 19.7301H20.693C20.2447 21.9235 18.5278 23.3633 16.2404 23.3633C13.5808 23.3633 11.4727 21.3913 11.4727 18.6469C11.4727 15.9024 13.5808 13.9305 16.2404 13.9305C18.5522 13.9305 20.28 15.3973 20.7066 17.6312H18.8782C18.6011 16.4184 17.5036 15.662 16.2404 15.662C14.4528 15.662 13.2629 16.9289 13.2629 18.6469C13.2629 20.3649 14.6158 21.6074 16.2404 21.6074M28.324 23.1796H26.6424V19.4086C26.6424 18.5415 26.1344 18.0742 25.352 18.0742C24.48 18.0742 23.9204 18.6064 23.9204 19.6815V23.1796H22.2387V13.9575H23.9204V17.4259C24.3224 16.8181 24.9744 16.5183 25.86 16.5183C26.5772 16.5183 27.164 16.7506 27.6177 17.2314C28.0877 17.7096 28.3213 18.3579 28.3213 19.2006V23.1796H28.324Z",
    fill: "#020303"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2378_6142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaoChannelLogo);
export default __webpack_public_path__ + "static/media/kakao-channel-logo.70e426e7c2bad7aad2bbeb5d1715937b.svg";
export { ForwardRef as ReactComponent };